<template>
  <div v-if="editor" class="editor-wrapper" :class="{ disabled: readonly }">    
    <input
      ref="fileInput"
      @change="toggleImage"       
      type="file"      
      accept="image/jpeg, image/png"
      hidden
     />
    
    <editor-content :editor="editor" class="editor-content"></editor-content>

    <div class="toolbar">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('bold')" :class="{ active: isActive('bold') }"><v-icon>mdi-format-bold</v-icon></button>
        </template>
        <span>Negrito</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('italic')" :class="{ active: isActive('italic') }"><v-icon>mdi-format-italic</v-icon></button>
        </template>
        <span>Itálico</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('strike')" :class="{ active: isActive('strike') }"> <v-icon>mdi-format-strikethrough-variant</v-icon> </button>
        </template>
        <span>Tachado</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('heading1')" :class="{ active: isActive('heading', { level: 1 }) }"><v-icon>mdi-format-header-1</v-icon></button>
        </template>
        <span>Título 1</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('heading2')" :class="{ active: isActive('heading', { level: 2 }) }"><v-icon>mdi-format-header-2</v-icon></button>
        </template>
        <span>Título 2</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('heading3')" :class="{ active: isActive('heading', { level: 3 }) }"><v-icon>mdi-format-header-3</v-icon></button>
        </template>
        <span>Título 3</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('bulletList')" :class="{ active: isActive('bulletList') }"><v-icon>mdi-format-list-bulleted</v-icon></button>
        </template>
        <span>Lista com marcadores</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('orderedList')" :class="{ active: isActive('orderedList') }"><v-icon>mdi-format-list-numbered</v-icon></button>
        </template>
        <span>Lista numerada</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="editor.chain().focus().toggleBlockquote().run()" :class="{ 'is-active': editor.isActive('blockquote') }">
            <v-icon>mdi-format-quote-close</v-icon>
          </button>
        </template>
        <span>Citação</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('paragraph')" :class="{ 'is-active': editor.isActive('paragraph') }"><v-icon>mdi-format-paragraph</v-icon></button>
        </template>
        <span>Parágrafo</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('text-left')" :class="{ active: isActive('textAlign', { textAlign: 'left' })  }"><v-icon>mdi-format-align-left</v-icon></button>
        </template>
        <span>Alinhar à esquerda</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('text-center')" :class="{ 'is-active': editor.isActive({ textAlign: 'center' }) }"><v-icon>mdi-format-align-center</v-icon></button>
        </template>
        <span>Centralizar</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('text-right')" :class="{ active: isActive('text-right')  }"><v-icon>mdi-format-align-right</v-icon></button>
        </template>
        <span>Alinhar à direita</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('text-justify')" :class="{ active: isActive('text-justify')  }"><v-icon>mdi-format-align-justify</v-icon></button>
        </template>
        <span>Justificar</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('horizontalBar')" :class="{ active: isActive('horizontalBar') }"><v-icon>mdi-minus</v-icon></button>
        </template>
        <span>Linha horizontal</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('undo')" :class="{ active: isActive('undo') }"><v-icon>mdi-undo</v-icon></button>
        </template>
        <span>Desfazer</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('redo')" :class="{ active: isActive('redo') }"><v-icon>mdi-redo</v-icon></button>
        </template>
        <span>Refazer</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" @click="toggle('color')" :class="{ active: isActive('color', { color: '#958DF1' }) }"><v-icon>mdi-pen</v-icon></button>
        </template>
        <span>Cor de destaque</span>
      </v-tooltip>
    </div>

    <div v-if="!hideDetails" class="input-chip__details v-text-field__details">
      <div class="input-chip__messages v-messages red--text" :class="{ 'input-chip__error': errorMessage }">
        {{ errorMessage || messages }}
      </div>
      <div v-if="counter" class="input-chip__counter v-counter">{{ computedCounter }}</div>
    </div>
  </div>
</template>

<script>
import ListItem from '@tiptap/extension-list-item'
import TextStyle from '@tiptap/extension-text-style'
import { Editor, EditorContent } from "@tiptap/vue-2"
import StarterKit from "@tiptap/starter-kit"
import Image from '@tiptap/extension-image'
import Highlight from '@tiptap/extension-highlight'
import TextAlign from '@tiptap/extension-text-align'
// import { TableCell, TableKit } from '@tiptap/extension-table'

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
});

// const CustomTableCell = TableCell.extend({
//   addAttributes() {
//     return {
//       ...this.parent?.(),
//       backgroundColor: {
//         default: null,
//         parseHTML: element => element.getAttribute('data-background-color'),
//         renderHTML: attributes => {
//           return {
//             'data-background-color': attributes.backgroundColor,
//             style: `background-color: ${attributes.backgroundColor}`,
//           }
//         },
//       },
//     }
//   },
// })

export default {
  components: { EditorContent },
  props: {
    format: { type: String, default: 'html' },
    value: { type: String, default: '' },
    rules: { type: Array },    
    counter: [Boolean, Number],
    maxLength: Number,
    messages: String,
    hideDetails: Boolean,
    placeholder: {
      type: String,
    },
    readonly: Boolean,
  },
  data() {
    return {
      editor: null,
      errorMessage: '',
      textField: '',
    }
  },
  mounted() {
    const that = this;
    this.editor = new Editor({
      onUpdate() {
        that.updateValue();
      },
      onCreate({ editor }) {
        editor.commands.setContent(that.value);
      },
      extensions: [
        StarterKit,
        TextStyle.configure({ types: [ListItem.name] }),
        Image,
        Highlight,
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
      ],
      content: this.value,
      editorProps: {
        attributes: {
          spellcheck: 'false',
        },
      },
      editable: !this.readonly,
    })
  },
  beforeDestroy() {
    this.editor.destroy()
  },
  methods: {
    toggle(command) {
      switch (command) {
        case 'bold':
          this.editor.chain().focus().toggleBold().run()
          break
        case 'italic':
          this.editor.chain().focus().toggleItalic().run()
          break
        case 'strike':
          this.editor.chain().focus().toggleStrike().run()
          break
        case 'bulletList':
          this.editor.chain().focus().toggleBulletList().run()
          break
        case 'orderedList':
          this.editor.chain().focus().toggleOrderedList().run()
          break
        case 'heading1':
          this.editor.chain().focus().toggleHeading({ level: 1 }).run()
          break
        case 'heading2':
          this.editor.chain().focus().toggleHeading({ level: 2 }).run()
          break
        case 'heading3':
          this.editor.chain().focus().toggleHeading({ level: 3 }).run()
          break
        case 'blockquote':
          this.editor.chain().focus().toggleBlockquote().run()
          break
        case 'codeBlock':
          this.editor.chain().focus().toggleCodeBlock().run()
          break
        case 'horizontalBar':
          this.editor.chain().focus().setHorizontalRule().run()
          break
        case 'undo':
          this.editor.chain().focus().undo().run()
          break
        case 'redo':
          this.editor.chain().focus().redo().run()
          break
        case 'color':
          this.editor.chain().focus().toggleHighlight().run()
          break
        case 'paragraph':
          this.editor.chain().focus().setParagraph().run()
          break
        case 'text-center':
          this.editor.chain().focus().setTextAlign('center').run()
          break
        case 'text-left':
          this.editor.chain().focus().setTextAlign('left').run()
          break
        case 'text-right':
          this.editor.chain().focus().setTextAlign('right').run()
          break
        case 'text-justify':
          this.editor.chain().focus().setTextAlign('justify').run()
          break
        default:
          console.warn(`Comando ${command} não existe`)
      }
    },
    isActive(name, attrs = {}) {
      return this.editor.isActive(name, attrs)
    },
    toggleImage(event) {
      const image = event.target.files[0];
      toBase64(image).then((base64) => {
        this.editor.chain().focus().setImage({ src: base64 }).run();
        event.target.value = '';
      });      
    },
    updateValue() {
      if(this.format == 'json') {
        this.$emit('update:value', this.editor.getJSON());      
      } else {
        this.$emit('update:value', this.editor.getHTML());
      }
    },
    triggerInputFile() {
      this.$refs.fileInput.click();
    },
    validate: function () {
      if (!this.rules) {
        this.errorMessage = '';
        this.$emit('update:error', false);
        return;
      }

      const rules = Array.isArray(this.rules) ? this.rules : [this.rules];
      const hasError = rules.some((rule) => {
        const errorMessage = rule(this.value);
        const invalid = typeof errorMessage === 'string';

        if (invalid) {
          this.errorMessage = errorMessage;
        } else {
          this.errorMessage = '';
        }

        return invalid;
      });
      
      this.$emit('update:error', hasError);
    },
  },
  computed: {
    computedCounter: function () {
      if (!this.counter) {
        return '';
      }

      if (this.maxLength) {
        return `${this.length} / ${this.maxLength}`;
      }

      if (typeof this.counter === 'number') {
        return `${this.length} / ${this.counter}`;
      }

      return this.length;
    },
    length: function () {
      if (!this.value) return 0;
      return this.value.replace(/(<([^>]+)>)/gi, "").length;
    },
  },
  watch: {
    value(newValue) {
      if (!this.editor) return;
      if (this.editor.getHTML() !== newValue) {
        this.editor.commands.setContent(newValue);
      }
      this.validate();
    },
    readonly(val) {
      this.editor.setEditable(!val);
    }
  }
}
</script>

<style lang="scss">
.editor-wrapper {
  .toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    border: 1px solid #ddd;
    border-top: none;
    padding: 6px;
    border-radius: 0px 0px 6px 6px;
    background: #fafafa;
    margin-bottom: 1rem;
    
    .toolbar button {
      border: none;
      background: transparent;
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 4px;
    }

    .toolbar button.active {
      background: #007bff;
      color: white;
    }
  }

  .editor-content {    
    background: white;
    border: 1px solid #ddd;
    border-radius: 6px 6px 0px 0px;
    padding: 12px; 

    .tiptap {      
      padding: 1rem;     
      background: white;

      :first-child {
        margin-top: 0;
      }

      blockquote {
        border-left: 3px solid var(--gray-light);
        margin: 1.5rem 0 !important;
        padding-left: 1rem !important;
      }

      ul,
      ol {
        padding: 0 1rem;
        margin: 1.25rem 1rem 1.25rem 0.4rem;

        li p {
          margin-top: 0.25em;
          margin-bottom: 0.25em;
        }
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        line-height: 1.1;
        margin-top: 2.5rem;
        text-wrap: pretty;
      }

      h1,
      h2 {
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
      }

      h1 {
        font-size: 1.4rem;
      }

      h2 {
        font-size: 1.2rem;
      }

      h3 {
        font-size: 1.1rem;
      }

      h4,
      h5,
      h6 {
        font-size: 1rem;
      }

      code {
        background-color: var(--purple-light);
        border-radius: 0.4rem;
        color: var(--black);
        font-size: 0.85rem;
        padding: 0.25em 0.3em;
      }

      pre {
        background: var(--black);
        border-radius: 0.5rem;
        color: var(--white);
        font-family: 'Poppins';
        margin: 1.5rem 0;
        padding: 0.75rem 1rem;

        code {
          background: none;
          color: inherit;
          font-size: 0.8rem;
          padding: 0;
        }
      }

      hr {
        border: none;
        border-top: 1px solid var(--gray-light);
        margin: 2rem 0;
      }

      .tableWrapper {
        margin: 1.5rem 0;
        overflow-x: auto;

        
      table {
        border-collapse: collapse;
        margin: 0;
        overflow: hidden;
        table-layout: fixed;
        width: 100%;

        td,
        th {
          border: 1px solid var(--gray);
          box-sizing: border-box;
          min-width: 1em;
          padding: 6px 8px;
          position: relative;
          vertical-align: top;

          > * {
            margin-bottom: 0;
          }
        }

        th {
          background-color: var(--gray-light);
          font-weight: bold;
          text-align: left;
        }

        .selectedCell:after {
          background: var(--gray-light);
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          pointer-events: none;
          position: absolute;
          z-index: 2;
        }

        .column-resize-handle {
            background-color: var(--purple);
            bottom: -2px;
            pointer-events: none;
            position: absolute;
            right: -2px;
            top: 0;
            width: 4px;
          }
        }
      }

      &.resize-cursor {
        cursor: ew-resize;
        cursor: col-resize;
      }

    }

  }

  &.disabled {
    .toolbar {
      opacity: 0.6;
      pointer-events: none;
      background: #f0f0f0;
    }
    .editor-content {
      background: #f9f9f9;
      color: #666;
      .tiptap {
        background: #f9f9f9;
      }
    }
  }
}
</style>
